/**
 * SecurityPage — Security practices and commitments
 */
import StaticPageLayout from './StaticPageLayout';

export default function SecurityPage() {
  return (
    <StaticPageLayout title={<>Security <em style={{ fontStyle: 'italic', color: 'var(--brand)' }}>practices</em>.</>}>
      <p style={{ fontStyle: 'italic' }}>Last updated: May 2026</p>

      <p>At Connekted.in, security is not an afterthought. This page outlines the measures we take to protect your data and the commitments we make to our users.</p>

      <h3>1. Encryption</h3>
      <p>All data transmitted between your browser and our servers is encrypted using TLS 1.3. Data at rest is encrypted using AES-256. Database backups are encrypted and stored in geographically separate locations within the European Union.</p>

      <h3>2. Authentication</h3>
      <p>We support authentication via email and password, as well as social login through Google, Apple, and Meta. Passwords are hashed using bcrypt with appropriate salt rounds. We never store passwords in plain text. Social login uses industry-standard OAuth 2.0 flows, and we never receive or store your social media passwords.</p>

      <h3>3. Infrastructure</h3>
      <p>Our platform is hosted on infrastructure within the European Union, compliant with GDPR data residency requirements. We use containerised deployments with automated scaling, isolated network environments, and regular security patches.</p>

      <h3>4. Access controls</h3>
      <p>Access to production systems and user data is restricted to authorised personnel only, on a strict need-to-know basis. All access is logged and audited. We enforce multi-factor authentication for all team members with access to production infrastructure.</p>

      <h3>5. Data isolation</h3>
      <p>Each user's data is logically isolated. Your scan notifications, contact lists, notes, and profile data are accessible only to you (and, for public scan page data, to people who scan your QR code, limited to the information you choose to display).</p>

      <h3>6. QR code security</h3>
      <p>QR codes generated by Connekted.in encode a URL to your public scan page. They do not contain personal data directly. The QR code pattern is generated server-side with error correction level H for maximum reliability and tamper resistance.</p>

      <h3>7. Vulnerability reporting</h3>
      <p>If you discover a security vulnerability in Connekted.in, please report it responsibly to hello@connektedin.com. We take all reports seriously and will respond within 48 hours. We do not pursue legal action against security researchers who act in good faith.</p>

      <h3>8. Incident response</h3>
      <p>In the event of a data breach, we will notify affected users within 72 hours as required by GDPR. We maintain an incident response plan that includes containment, investigation, notification, and remediation procedures.</p>

      <h3>9. Regular audits</h3>
      <p>We conduct regular internal security reviews and code audits. As we grow, we plan to engage third-party security firms for penetration testing and compliance certification.</p>

      <h3>Contact</h3>
      <p>For security-related enquiries, email hello@connektedin.com.</p>
    </StaticPageLayout>
  );
}
